import { Box, Button, Center, FormControl, FormErrorMessage, Stack, Input, FormLabel } from '@chakra-ui/react'
import Select from 'react-select'
import React, { VFC } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useTitle } from 'react-use'
import { Container } from '../../../common/components/Container'
import { DebugLoginOption } from '../../../common/debugSession/DebugLoginOption'
import { DebugSignInRequest } from '../../../common/debugSession/DebugSignInRequest'
import { useAdminList } from '../../../common/debugSession/useAdminList'
import { useApproverList } from '../../../common/debugSession/useApproverList'
import { useDebugAdminSighnIn } from '../../../common/debugSession/useDebugAdminSighnIn'
import { useDebugApproverSighnIn } from '../../../common/debugSession/useDebugApproverSignIn'
import { useDebugProfessorSighnIn } from '../../../common/debugSession/useDebugProfessorSignIn'
import { useProfessorList } from '../../../common/debugSession/useProfessorList'
import { reactSelectStyles } from '../../../common/form/ReactSelectStyles'
import { Title } from '../../manager/common/atoms/title/Title'
import { useOfficeList } from '../../../common/debugSession/useOfficeList'
import { useDebugOfficeSighnIn } from '../../../common/debugSession/useDebugOfficeSignIn'
import { useDebugApplicantSignIn, DebugApplicantSignInRequest } from '../../../common/debugSession/useDebugApplicantSignIn'



export const AdminDebugLogin: VFC = () => {
  const options = useAdminList()
  const { signIn, loginError } = useDebugAdminSighnIn()
  return <DebugLogin
    options={options}
    signIn={signIn}
    loginError={loginError}
  />
}

export const ApproverDebugLogin: VFC = () => {
  const options = useApproverList()
  const { signIn, loginError } = useDebugApproverSighnIn()
  return <DebugLogin
    options={options}
    signIn={signIn}
    loginError={loginError}
  />
}

export const OfficeDebugLogin: VFC = () => {
  const options = useOfficeList()
  const { signIn, loginError } = useDebugOfficeSighnIn()
  return <DebugLogin
    options={options}
    signIn={signIn}
    loginError={loginError}
  />
}

export const ProfessorDebugLogin: VFC = () => {
  const options = useProfessorList()
  const { signIn, loginError } = useDebugProfessorSighnIn()
  return <DebugLogin
    options={options}
    signIn={signIn}
    loginError={loginError}
  />
}

export const ApplicantDebugLogin: VFC = () => {
  const { signIn, loginError } = useDebugApplicantSignIn()
  return <ApplicantDebugLoginForm
    signIn={signIn}
    loginError={loginError}
  />
}


const DebugLogin: VFC<{
  options: DebugLoginOption[],
  signIn: (data: DebugSignInRequest) => void,
  loginError: boolean
}> = ({ options, signIn, loginError }) => {
  useTitle(`ログイン画面【ステージング環境】`)
  const { control, handleSubmit, formState: { errors } } = useForm<DebugSignInRequest>()
  const customStyles = reactSelectStyles(errors?.key !== undefined && errors?.key !== null)
  return (
    <Container bgColor={'gray'} innerWidth={'1280px'} pb={16}>
      <Center h='100%'>
        <Box w={'776px'}>
          <Stack justifyContent={'center'}>
            <Title text={`ログインするアカウントを選択してください。`} />
            <Stack justifyContent={'center'}>
              <FormControl isInvalid={errors?.key !== undefined && errors?.key !== null}>
                <Controller
                  name="key"
                  control={control}
                  render={({ field }) => (
                    <Select
                      classNamePrefix="reactSelect"
                      styles={customStyles}
                      placeholder={'選択してください (検索可能)'}
                      isSearchable={true}
                      isClearable={true}
                      options={options}
                      value={options.find((option) => option.value === field.value)}
                      onChange={(updated) => {
                        field.onChange(updated?.value)
                      }}
                      menuFontsize={'12px'}
                    ></Select>
                  )}
                />
                {/* {options?.map(option => <option key={option.key} value={option.key}>{option.displayName}</option>)} */}
                <FormErrorMessage>{'必須入力です。'}</FormErrorMessage>
              </FormControl>
            </Stack>
            <FormControl isInvalid={loginError}>
              <Button onClick={handleSubmit((data) => signIn(data))}>ログイン</Button>
              <FormErrorMessage>ログインに失敗しました。</FormErrorMessage>
            </FormControl>
          </Stack>
        </Box>
      </Center>
    </Container >
  )
}

const ApplicantDebugLoginForm: VFC<{
  signIn: (data: DebugApplicantSignInRequest) => void,
  loginError: boolean
}> = ({ signIn, loginError }) => {
  useTitle(`申請者ログイン画面【開発環境】`)
  const { register, handleSubmit, formState: { errors } } = useForm<DebugApplicantSignInRequest>()

  return (
    <Container bgColor={'gray'} innerWidth={'1280px'} pb={16}>
      <Center h='100%'>
        <Box w={'776px'}>
          <Stack justifyContent={'center'}>
            <Title text={`申請者デバッグログイン`} />
            <Stack justifyContent={'center'} spacing={4}>
              <FormControl isInvalid={errors?.email !== undefined}>
                <FormLabel htmlFor="email">メールアドレス</FormLabel>
                <Input
                  id="email"
                  type="email"
                  placeholder="test@example.com"
                  {...register("email", {
                    required: "メールアドレスは必須です",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "有効なメールアドレスを入力してください"
                    }
                  })}
                />
                <FormErrorMessage>
                  {errors.email && errors.email.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={loginError}>
                <Button onClick={handleSubmit((data) => signIn(data))} colorScheme="blue">
                  ログイン
                </Button>
                <FormErrorMessage>ログインに失敗しました。</FormErrorMessage>
              </FormControl>
            </Stack>
          </Stack>
        </Box>
      </Center>
    </Container>
  )
}

export default DebugLogin